/**
 * Repères datés du tableau de bord admin : les changements qui déplacent les chiffres sans que les
 * utilisateurs y soient pour quelque chose. Sans eux, une rupture dans une courbe se lirait comme
 * un progrès ou une régression des utilisateurs.
 */
export interface RepereAdmin {
  date: string; // JJ/MM/AAAA
  texte: string;
}

export const REPERES_ADMIN: RepereAdmin[] = [
  {
    date: '25/09/2026',
    // Écarts mesurés sur les mêmes documents de test, notés par les deux modèles.
    texte:
      'Modèle IA : passage de Sonnet 4.6 vers Sonnet 5 (17h03 UTC). Les notes de CV montent de 2 à 14 points à document égal, les notes LinkedIn et lettre bougent peu : comparer avant et après avec prudence.',
  },
  {
    date: '18/10/2026',
    // Heure exacte du changement du secret inconnue : entre le dernier appel Sonnet (11h37 UTC)
    // et le premier appel Haiku (19h12 UTC). Aucune comparaison de qualité n'a été mesurée.
    texte:
      'Modèle IA : passage de Sonnet 5 vers Haiku 5.5 (entre 11h37 et 19h12 UTC). Les coûts par appel baissent. Qualité des notes et des textes non mesurée : comparer avant et après avec prudence.',
  },
];
